import { render } from "./TransferAccount.vue?vue&type=template&id=265c8a53&scoped=true&lang=pug"
import script from "./TransferAccount.vue?vue&type=script&lang=js"
export * from "./TransferAccount.vue?vue&type=script&lang=js"

import "./TransferAccount.scss?vue&type=style&index=0&id=265c8a53&scoped=true&lang=scss"

import exportComponent from "/builds/wiwdata/applications/finance-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-265c8a53"]])

export default __exports__